
import {computed, ref, } from "vue";
import {useRoute} from "vue-router";

export function useIframeScript (prayerWallId){

    let hideTitleHeader = ref(false);
    let marginlessMode = ref(false);

    let iFrameScript = computed(() =>{
        let domain = window.location.origin;
        return `<iframe src="${domain}/walls/${prayerWallId}?hideTitleHeader=${hideTitleHeader.value}&marginlessMode=${marginlessMode.value}" width="100%" height="1000" frameborder="0"></iframe>`
    })


    return {iFrameScript, hideTitleHeader, marginlessMode};
    
}